import styled from 'styled-components';

import { mediaMin } from '@spa/shared/theme';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: ${props => props.theme.space(4)};
  cursor: pointer;
  text-decoration: none;

  ${mediaMin.smallBreakpoint`
    flex-direction: column;
  `};
`;

export const Photos = styled.div`
  min-width: 100%;
  overflow: hidden;
  will-change: transform;
  position: relative;
  display: flex;
  flex-direction: row;

  [loading='lazy'] {
    position: absolute;
    height: 100%;
    width: 100%;
  }

  ${mediaMin.smallBreakpoint`
    height: 200px;
  `};

  [aria-label] {
    position: absolute;
    z-index: 1;
    top: calc(50% - 15px);
    opacity: 0;
  }

  [aria-label='previous'] {
    left: ${props => props.theme.space(3)};
  }

  [aria-label='next'] {
    right: ${props => props.theme.space(3)};
  }

  &:hover {
    [aria-label] {
      opacity: 1;
    }
  }

  img {
    width: 100%;
    height: 100%;
    display: block;
    object-fit: cover;
    object-position: center center;
    will-change: transform;
    background: transparent;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    border-radius: 12px;
  }

  > div > span {
    ${mediaMin.smallBreakpoint`
      height: 200px;
    `};
  }
`;

export const ScrollIndicatorContainer = styled.div`
  position: absolute;
  display: flex;
  width: 100%;
  justify-content: center;
  bottom: 12px;
`;
